// Define Tailwind default colors
export const TAILWIND_COLORS = [
  { name: 'Red', value: '#ef4444', bgClass: 'bg-red-500' },
  { name: 'Orange', value: '#f97316', bgClass: 'bg-orange-500' },
  { name: 'Yellow', value: '#eab308', bgClass: 'bg-yellow-500' },
  { name: 'Green', value: '#22c55e', bgClass: 'bg-green-500' },
  { name: 'Emerald', value: '#10b981', bgClass: 'bg-emerald-500' },
  { name: 'Cyan', value: '#06b6d4', bgClass: 'bg-cyan-500' },
  { name: 'Blue', value: '#3b82f6', bgClass: 'bg-blue-500' },
  { name: 'Violet', value: '#8b5cf6', bgClass: 'bg-violet-500' },
  { name: 'Purple', value: '#a855f7', bgClass: 'bg-purple-500' },
  { name: 'Indigo', value: '#615fff', bgClass: 'bg-indigo-500' },
  { name: 'Gray 200', value: '#ebecf4', bgClass: 'bg-gray-200' },
  { name: 'Gray 400', value: '#9294aa', bgClass: 'bg-gray-400' },
  { name: 'Gray', value: '#6b7280', bgClass: 'bg-gray-500' },
  { name: 'Black', value: '#0f0d18', bgClass: 'bg-gray-950' },
];

// Helper function to determine contrasting text color
export function getContrastingTextColor(bgColor: string | undefined): string {
  // If bgColor is undefined (Default), return black text.
  if (!bgColor) {
    return '#000000'; // Default to black text for the "Default" button state
  }

  // Existing logic for when a specific color is selected
  const color = bgColor.substring(1); // strip #
  // Ensure hex is valid before parsing
  if (color.length !== 6) return '#000000'; // Fallback for invalid hex
  const rgb = parseInt(color, 16); // convert rrggbb to decimal
  const r = (rgb >> 16) & 0xff; // extract red
  const g = (rgb >> 8) & 0xff; // extract green
  const b = (rgb >> 0) & 0xff; // extract blue

  const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

  return luma < 128 ? '#FFFFFF' : '#000000'; // White text on dark, Black text on light
}

// Helper function to convert hex color with opacity to rgba
export function hexToRgba(hex: string, opacity: number): string {
  // Remove the hash if it exists
  hex = hex.replace('#', '');
  
  // Parse the hex values
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  
  // Return the rgba value
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

// Helper function to validate hex color
export function isValidHex(hex: string): boolean {
  return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hex);
}
